import { hoc } from '@/lib';
import { UiToast } from '@/components';
import { globalStore } from '@/stores';

import room from '../../lib/room';
import PopupInvite from './popup-invite';
import PopupResult from './popup-result';
import gamesFightUtils from './utils';
import gamesFightStore from './store';

const handleGamesFightSocket = (socket) => {
  // 厅战邀请
  socket.on('funny_room.room_war_invite', (msg) => {
    const { data: item = {} } = msg;
    if (item.target === room.getRoomId()) {
      hoc.render(
        { item, stage: 'accept', key: 'fightInviteAccept' },
        PopupInvite,
      );
    }
  });

  // 厅战状态变化
  socket.on('funny_room.room_war_status_change', () => {
    gamesFightUtils.fetchGamesFightInfo();
  });

  // 厅战分数变化
  socket.on('funny_room.room_war_score_change', (msg) => {
    const { pkCamps = [] } = msg.data;
    gamesFightStore.store.updateInfo({ pkCamps });
  });

  // 厅战结果
  socket.on('funny_room.room_war_result', (msg) => {
    const { data: item } = msg;
    globalStore.modal.remove('fightRankUsers');
    hoc.render({ item }, PopupResult);
  });

  // 厅战邀请他人处理
  socket.on('funny_room.room_war_handle_result', (msg) => {
    globalStore.modal.remove('fightInviteAccept');
    UiToast.text(msg.data.msg || '邀请已其他主持人处理');
  });

  // 厅战消息提示
  socket.on('funny_room.room_seat_msg_notice', (msg) => {
    const { msg: text } = msg.data;
    UiToast.text(text);
  });
};

export default handleGamesFightSocket;
